import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin session lives in an httpOnly cookie set by the backend (not readable by JS)
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname.startsWith("/admin/")) {
      window.location.href = "/admin";
    }
    return Promise.reject(error);
  }
);
